import { isAndroid } from "@tamagui/constants";
const IS_FABRIC = typeof global < "u" && !!(global._IS_FABRIC ?? global.nativeFabricUIManager),
  USE_NATIVE_PORTAL = process.env.TAMAGUI_USE_NATIVE_PORTAL && process.env.TAMAGUI_USE_NATIVE_PORTAL !== "false" ? !0 : !isAndroid && !IS_FABRIC,
  allPortalHosts = /* @__PURE__ */new Map(),
  portalListeners = {};
export { IS_FABRIC, USE_NATIVE_PORTAL, allPortalHosts, portalListeners };
//# sourceMappingURL=constants.mjs.map
